import { _ } from "@icc/shared/helpers";

// Prywatna, Publiczna, Wewnętrzna, Dystrybutor - Producent
export type ComplaintNoteVisibility = 'private' | 'public' | 'internal' | 'manufacturerDistributor';

export const ComplaintNotesVisibility: Record<ComplaintNoteVisibility, string> = {
    private: _('COMPLAINT|Prywatna'),
    public: _('COMPLAINT|Publiczna'),
    internal: _('COMPLAINT|Wewnętrzna'),
    manufacturerDistributor: _('COMPLAINT|Dystrybutor - Producent'),
};

export const ComplaintNotesVisibilityColors: Record<ComplaintNoteVisibility, string> = {
    private: '76777A',
    public: '76777A',
    internal: '76777A',
    manufacturerDistributor: '76777A',
};

export const complaintNotesVisibility = Object.keys(ComplaintNotesVisibility).map((key) => ({
    value: key,
    label: ComplaintNotesVisibility[key],
}));